import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

interface List {
  label: string;
  link: string;
}
interface ListSearchDistanceType {
  onKeyword: List;
  project?: Array<List>;
  recommended?: Array<List>;
  mall?: Array<List>;
  university?: Array<List>;
  hospital?: Array<List>;
  popular_area?: Array<List>;
  road?: Array<List>;
  airport?: Array<List>;
  train?: Array<List>;
  park?: Array<List>;
  location_type?: Array<List>;
}

type SearchBarProps = {
  finalKeyword: string;
  keyword: string;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
  listSearchDistance?: ListSearchDistanceType;
  insertHistory: (url: any) => any;
};

export default function SearchBar({
  finalKeyword,
  keyword,
  setKeyword,
  listSearchDistance,
  insertHistory,
}: SearchBarProps) {
  const handleKeydown = (e: any) => {
    if (e.key === 'Enter') {
      insertHistory(listSearchDistance?.onKeyword.link);
      window.open(listSearchDistance?.onKeyword.link, '_blank');
      handleDeleteKeyword();
    }
  };

  const handleDeleteKeyword = () => {
    setKeyword('');
  };

  return (
    <div className={`searchbar border-2 ${finalKeyword ? 'rounded-t-2xl border-b-0' : 'rounded-full'} flex flex-col `}>
      <div className="flex items-center gap-x-4 px-3 py-1.5 text-inherit border-inherit">
        <SearchIcon color="disabled" />
        <input
          id="search_keyword"
          className="w-full border-none focus:outline-none text-lg"
          type="text"
          value={keyword}
          onChange={(e) => {
            setKeyword(e.target.value);
          }}
          onKeyPress={handleKeydown}
        />
        {keyword && (
          <IconButton
            color="inherit"
            aria-label="upload picture"
            component="span"
            onClick={handleDeleteKeyword}
            sx={{
              padding: 0,
            }}>
            <CloseIcon />
          </IconButton>
        )}
      </div>
    </div>
  );
}
